import { useEffect } from 'react';
import { account_service } from '../services/account_service';
import {useNavigate } from 'react-router-dom';

const AuthGuuardClient = ({ children }) => {
    const navigate = useNavigate();

    let tokenClient =  localStorage.getItem('tokenClient')

    useEffect(() => {
        if (!account_service.isLoggedClient() || !tokenClient) {
            navigate('/auth/loginClient');
        }
      }, [tokenClient, navigate]);

    return children;
};

export default AuthGuuardClient; 